import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  const features = [
    {
      icon: '📊',
      title: 'Suivi Personnalisé',
      description: 'Suivez votre progression et vos objectifs de poids de manière intuitive et personnalisée.'
    },
    {
      icon: '🥗',
      title: 'Conseils Nutritionnels',
      description: 'Recevez des recommandations alimentaires adaptées à vos besoins et objectifs.'
    },
    {
      icon: '📱',
      title: 'Interface Intuitive',
      description: 'Une expérience utilisateur fluide et agréable pour vous accompagner au quotidien.'
    }
  ];

  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Prenez le contrôle de votre santé</h1>
          <p className="hero-subtitle">
            WeightGuardian vous aide à atteindre vos objectifs de poids de manière saine et durable, avec un suivi personnalisé et des conseils d'experts.
          </p>
          <Link to="/register" className="cta-button">
            Commencer Maintenant
          </Link>
        </div>
        <div className="hero-image">
          <img 
            src="/assets/hero-image.png" 
            alt="Weight Guardian App Interface"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/600x400?text=Weight+Guardian';
            }}
          />
        </div>
      </section>

      <section className="features-section">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home; 